import {Utilities} from '@shared/utilities/utilities.model';
import {VehicleNature} from '../../../claims/claims-commons/models/vehicle.model';
import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';

export enum CarShapeTypes {
	INTERNAL = 'INTERNAL',
	EXTERNAL = 'EXTERNAL',
	TIRES = 'TIRES'
}

export class CarShapeModel {

	carShapesMap: Map<string, CarShapeItemModel[]> = new Map<string, CarShapeItemModel[]> ();

	getNewCarShapeModel(nature?: VehicleNature): CarShapeModel {
		Object.keys (CarShapeTypes).forEach (carShapeType => this.carShapesMap.set (carShapeType, this.getNewCarShapeItemList (CarShapeTypes[carShapeType], nature)));
		return this;
	}

	getNewCarShapeItemList(carShapeType: CarShapeTypes, nature?: VehicleNature): CarShapeItemModel[] {
		return carShapes[carShapeType]
			.filter (t => !nature || t.natures.indexOf (nature) > -1)
			.map (t => new CarShapeItemModel ({impactPointType: t.value, checked: false}));
	}

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			let value: any;
			Object.keys (model).forEach (key => {
				value = model[key];
				if (!Utilities.isVoid (value)) {
					this.setCarShape (key, value);
				}
			});
		}
	}

	private setCarShape(key: string, value: CarShapeItemModel[]): void {
		const carShapeItems: CarShapeItemModel[] = [];
		value.forEach (item => carShapeItems.push (new CarShapeItemModel (item)));
		this.carShapesMap.set (key, carShapeItems);
	}
}

export class CarShapeItemModel {
	impactPointType: ImpactPointTypes;
	checked: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.impactPointType = model.impactPointType;
			this.checked = model.checked ? model.checked : false;
		}
	}
}

const carShapes: { [key: string]: { natures: VehicleNature[], value: ImpactPointTypes }[] } = {
	[CarShapeTypes.EXTERNAL]: [
		{
			natures: [VehicleNature.MOTORCYCLE, VehicleNature.MOTORVEHICLE, VehicleNature.VAN],
			value: ImpactPointTypes.FRONT
		},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_R},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_L},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.WINDSHIELD},
		{
			natures: [VehicleNature.MOTORCYCLE, VehicleNature.MOTORVEHICLE, VehicleNature.VAN],
			value: ImpactPointTypes.REAR
		},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_R},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_L},
		{natures: [VehicleNature.MOTORVEHICLE], value: ImpactPointTypes.REAR_WINDOW},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.ROOF},
		{
			natures: [VehicleNature.MOTORCYCLE, VehicleNature.MOTORVEHICLE, VehicleNature.VAN],
			value: ImpactPointTypes.SIDE_FRONT_L
		},
		{
			natures: [VehicleNature.MOTORCYCLE, VehicleNature.MOTORVEHICLE, VehicleNature.VAN],
			value: ImpactPointTypes.SIDE_FRONT_R
		},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.SIDE_REAR_R},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.SIDE_REAR_L}
	],
	[CarShapeTypes.INTERNAL]: [
		{
			natures: [VehicleNature.MOTORCYCLE, VehicleNature.MOTORVEHICLE, VehicleNature.VAN],
			value: ImpactPointTypes.REAR_SEAT
		},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_SEAT_L},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_SEAT_R},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_BACK},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_BACK_L},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_BACK_R},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.MIDDLE_SEAT},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.MIDDLE_SEAT_L},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.MIDDLE_SEAT_R},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.MIDDLE_BACK},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.MIDDLE_BACK_L},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.MIDDLE_BACK_R},
		{natures: [VehicleNature.MOTORCYCLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_SEAT},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_SEAT_L},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_SEAT_R},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.FRONT_BACK},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_BACK_L},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_BACK_R},
	],
	[CarShapeTypes.TIRES]: [
		{natures: [VehicleNature.MOTORCYCLE], value: ImpactPointTypes.FRONT},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_R},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.FRONT_L},
		{natures: [VehicleNature.MOTORCYCLE], value: ImpactPointTypes.REAR},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_R},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.REAR_R_INT},
		{natures: [VehicleNature.VAN], value: ImpactPointTypes.REAR_L_INT},
		{natures: [VehicleNature.MOTORVEHICLE, VehicleNature.VAN], value: ImpactPointTypes.REAR_L},
	]
};
